import React, { PureComponent } from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Pagination from "react-js-pagination";

import {
  assignFeeDues,
  createFeeBundle,
  updateFeeBundle,
  getFeesInBundle,
  toggleFeeBundleStatus,
  getStudentsData,
} from "../../actions";
import { Text, ModalView, Loader } from "../common";
import { convertToCurrencyFormat, isMobileDevice } from "../../helpers/Utils";
import StyleConstants from "../../shared/constants/styleConstants/styles";
import { withRouter } from "react-router-dom";
import Edit from "./edit";

const IS_MOBILE = isMobileDevice();

const customDropdownStyles = {
  control: (base, state) => ({
    ...base,
    height: 35,
    width: 200,
    backgroundColor: "white",
    border: "1px solid #CDCFD6 !important",
  }),
  indicatorsContainer: (base, state) => ({
    ...base,
    height: 35,
  }),
  valueContainer: (base, state) => ({
    ...base,
    height: 40,
  }),
  option: (base, state) => ({
    ...base,
    textAlign: "left",
  }),
};

const dueAssignmentTypeDropdownOptions = [
  // { value: 1, label: "Institute" },
  { value: 2, label: "Campuses" },
  { value: 3, label: "Classrooms" },
  { value: 4, label: "Students" },
];

class List extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      studentId: null,
      emailError: "",
      listToChooseFrom: [],
      selectedFeeBundle: {},
      displayFeeForm: false,
      selectedTypeToAssignDue: "",
      selectedPageType: null,
      showEditModal: false,
      selectedItemsToAssignDue: [],
      newFeeDetails: {
        name: "",
        academic_year: [],
      },
      currentFeeDetails: {
        name: "",
        academic_year: [],
      },
      hasAccess: true,
      addfeebundle: false,
      page: 1,
      perPage: 5,
      campus: [],
      classroom: [],
      campusId: "",
      classroomId: "",
      searchString: "",
      filteredStudents: this.props.students,
      selectedCampus: "",
      selectedInstitutesTagIds: null,
      loader: false,
      activeFeeBundles: [],
      inactiveFeeBundles: [],
    };
    this.handleCloseEditModal = this.handleCloseEditModal.bind(this);
    this.handleCloseFeeDueAssignmentModal =
      this.handleCloseFeeDueAssignmentModal.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  componentDidMount() {
    this.props.getFeesInBundle().then(() => {
      this.filterFeeBundles();
    });
  }

  filterFeeBundles() {
    const { feeBundles } = this.props;
    this.setState({
      activeFeeBundles: feeBundles.filter((x) => x.active),
      inactiveFeeBundles: feeBundles.filter((x) => !x.active),
    });
  }

  handleCloseEditModal() {
    this.setState({
      showEditModal: false,
      displayFeeForm: false,
      displayFeeAccountForm: false,
      currentFeeDetails: { name: "", academic_year: [] },
      newFeeDetails: { name: "", academic_year: [] },
      currentFeeAccount: {
        name: "",
        address: "",
        gst_number: "",
        contact_number: "",
        contact_email: "",
      },
    });
  }

  handleFormSubmit(event, isEditForm) {
    event.preventDefault();
    const { newFeeDetails, currentFeeDetails } = this.state;
    const feeDetails = isEditForm ? currentFeeDetails : newFeeDetails;
    const { name, academic_year } = feeDetails;
    if (isEditForm) {
      this.props
        .updateFeeBundle(name, feeDetails.id, academic_year)
        .then((response) => {
          if (response.success) {
            this.handleCloseEditModal();
            window.location.reload();
          }
        });
    } else {
      this.props.createFeeBundle(name, academic_year).then((response) => {
        if (response.success) {
          this.setState({
            newFeeDetails: {
              name: "",
              acadmic_year: [],
            },
            displayFeeForm: false,
            showEditModal: false,
          });
          window.location.reload();
        }
      });
    }
  }

  handleInputChange(event, type, isEditForm) {
    if (isEditForm) {
      const { academic_year } = this.state.currentFeeDetails;
      if (type === "academicYear0") {
        this.setState({
          currentFeeDetails: {
            ...this.state.currentFeeDetails,
            academic_year: [
              event.target.value,
              academic_year[1] || parseInt(event.target.value, 10) + 1,
            ],
          },
        });
      } else if (type === "academicYear1") {
        this.setState({
          currentFeeDetails: {
            ...this.state.currentFeeDetails,
            academic_year: [
              academic_year[0] || parseInt(event.target.value, 10) - 1,
              event.target.value,
            ],
          },
        });
      } else {
        this.setState({
          currentFeeDetails: {
            ...this.state.currentFeeDetails,
            [type]: event.target.value,
          },
        });
      }
    } else {
      const { academic_year } = this.state.newFeeDetails;
      if (type === "academicYear0") {
        this.setState({
          newFeeDetails: {
            ...this.state.newFeeDetails,
            academic_year: [
              event.target.value,
              academic_year[1] || parseInt(event.target.value, 10) + 1,
            ],
          },
        });
      } else if (type === "academicYear1") {
        this.setState({
          newFeeDetails: {
            ...this.state.newFeeDetails,
            academic_year: [
              academic_year[0] || parseInt(event.target.value, 10) - 1,
              event.target.value,
            ],
          },
        });
      } else {
        this.setState({
          newFeeDetails: {
            ...this.state.newFeeDetails,
            [type]: event.target.value,
          },
        });
      }
    }
  }

  handleCloseFeeDueAssignmentModal() {
    this.setState({
      showEditModal: false,
      selectedTypeToAssignDue: "",
      selectedItemsToAssignDue: [],
    });
  }

  renderSubHeading(text) {
    return (
      <Text
        color={StyleConstants.textColor.primary}
        fontSize={StyleConstants.textSize.secondaryHeader}
        fontWeight={StyleConstants.textWeight.bold}
        style={{ textDecoration: "underline" }}
        text={text}
      />
    );
  }

  renderTitle(text, underline = false) {
    return (
      <Text
        style={{ textDecoration: underline && "underline" }}
        fontSize={StyleConstants.textSize.title}
        color={StyleConstants.color.dark}
        text={text}
      />
    );
  }

  renderModal() {
    const { showEditModal, displayFeeForm } = this.state;
    return (
      <ModalView
        key={showEditModal}
        header={"Assign Fee Details"}
        isModalVisible={showEditModal}
        handleCloseModal={this.handleCloseEditModal}
        maxWidth={1000}
      >
        {displayFeeForm
          ? this.renderFeeForm(true)
          : this.feeDueAssignmentForm()}
      </ModalView>
    );
  }

  renderFeeDueAssignedItems(
    feeId,
    assignedItemIds,
    isCampusList = true,
    isStudentList = false,
    isFullListView = false
  ) {
    const { campuses, classrooms, students } = this.props;
    let itemList = isCampusList
      ? campuses
      : isStudentList
      ? students
      : classrooms;
    const feeDueAssignedItems = itemList.filter((item) => {
      return assignedItemIds.indexOf(item.value) >= 0;
    });

    return (
      <div
        style={{
          display: "flex",
          margin: isFullListView && "20px auto",
          flexWrap: isFullListView && "wrap",
          width: isFullListView ? window.innerWidth - 50 : 350,
          overflow: "auto",
        }}
      >
        {feeDueAssignedItems.map((assignedItem) => {
          return (
            <div
              style={{
                cursor: isStudentList && !isFullListView ? "pointer" : "auto",
                backgroundColor:
                  !isFullListView && StyleConstants.backgroundColor.error,
                padding: 10,
                marginRight: 5,
                whiteSpace: "nowrap",
                wordBreak: "unset",
                borderRadius: 5,
              }}
              onClick={
                isStudentList && !isFullListView
                  ? () => window.open(`?fee_id=${feeId}&show_student_ids=true`)
                  : () => {}
              }
            >
              {isStudentList ? assignedItem.student_id : assignedItem.label}
            </div>
          );
        })}
      </div>
    );
  }

  handleSelectedStudents(studentId) {
    let { selectedItemsToAssignDue } = this.state;
    if (selectedItemsToAssignDue.indexOf(studentId) > -1)
      selectedItemsToAssignDue = selectedItemsToAssignDue.filter(
        (selectedItemsToAssignDue) => selectedItemsToAssignDue !== studentId
      );
    else selectedItemsToAssignDue = [...selectedItemsToAssignDue, studentId];
    this.setState({ selectedItemsToAssignDue });
  }

  handleSelectAllStudents(filteredStudents, feeDueAssignedItems) {
    let { selectedItemsToAssignDue } = this.state;
    let unassignedStudents = filteredStudents.filter(
      (x) => !feeDueAssignedItems.includes(x)
    );
    unassignedStudents = unassignedStudents.map((x) => {
      return x.id;
    });
    selectedItemsToAssignDue =
      selectedItemsToAssignDue.length === unassignedStudents.length
        ? []
        : [...unassignedStudents];
    this.setState({ selectedItemsToAssignDue });
  }

  renderMultiSelect(
    options,
    selectedOption,
    key,
    placeholder,
    selectedFunction
  ) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          marginTop: 30,
        }}
      >
        <div style={{ marginBottom: 5 }} className="heading-3">
          {placeholder}:
        </div>
        <Select
          value={selectedOption}
          onChange={selectedFunction}
          options={options}
          placeholder={placeholder}
          styles={customDropdownStyles}
          isSearchable
          isMulti
          isClearable
        />
      </div>
    );
  }

  renderDropDown(
    filterItems,
    selectedItem,
    selectedFunction,
    item,
    defaultValue = ""
  ) {
    const defaultSelectedValue = defaultValue || { label: item, value: 0 };
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          marginTop: 30,
        }}
      >
        <div style={{ marginBottom: 5 }} className="heading-3">
          {item}
        </div>
        <Select
          styles={customDropdownStyles}
          value={selectedItem || defaultSelectedValue}
          onChange={selectedFunction}
          options={filterItems}
          placeholder="All"
          maxMenuHeight={150}
          required
        />
      </div>
    );
  }

  feeDueAssignmentForm() {
    const labelStyle = {
      display: "flex",
      justifyContent: "flex-start",
      width: 185,
    };
    const containerStyle = {
      display: "flex",
      margin: "10px 0px",
      maxWidth: 700,
      alignItems: "center",
    };
    const { campuses, classrooms, students, institutesTags } = this.props;
    let filteredClassrooms = classrooms;
    const width = 100;
    const {
      selectedTypeToAssignDue,
      selectedItemsToAssignDue,
      selectedFeeBundle,
      page,
      perPage,
      filteredStudents,
      selectedCampus,
      classroomId,
      loader,
    } = this.state;
    const enableButtonToAssign =
      selectedTypeToAssignDue.value === 1 ||
      selectedItemsToAssignDue.length > 0;
    const feeDueAssignedItems = students?.filter((item) => {
      return selectedFeeBundle.student_ids.indexOf(item.value) >= 0;
    });
    let filteredStudent = [];
    let sample = [500031, 129, 130];
    if (loader) {
      return <Loader />;
    }
    return (
      <form>
        <fieldset
          style={{
            height: 500,
            width: !IS_MOBILE && 800,
            overflow: "auto",
          }}
        >
          <legend>Fee Due Details:</legend>
          <div style={containerStyle}>
            <label style={labelStyle} htmlFor="fee_name">
              Fee Name:
            </label>
            <div
              style={{
                marginLeft: 5,
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                maxWidth: 350,
              }}
            >
              {this.renderTitle(selectedFeeBundle.name)}
            </div>
          </div>
          <div style={containerStyle}>
            <div
              style={{
                alignItems: "center",
                marginTop: -20,
                marginLeft: 20,
                marginBottom: 5,
              }}
            >
              {this.renderDropDown(
                campuses,
                this.state.selectedCampus,
                (event) =>
                  this.setState({
                    selectedCampus: event,
                    studentCampus: event.label,
                  }),
                "Campuses"
              )}
            </div>
            <div
              style={{
                alignItems: "center",
                marginTop: -20,
                marginLeft: 40,
                marginBottom: 5,
              }}
            >
              {this.renderDropDown(
                filteredClassrooms.filter(
                  (classroom) => classroom.campus_id === selectedCampus.value
                ),
                this.state.selectedClassroom,
                (event) => {
                  this.setState({
                    selectedClassroom: event,
                    classroomId: event.value,
                  });
                  filteredStudent = students?.filter((item) => {
                    return item.classroom_id === event.value;
                  });
                  this.setState({ filteredStudents: filteredStudent, page: 1 });
                },
                "Classrooms"
              )}
            </div>
            <div
              style={{
                alignItems: "center",
                marginTop: -20,
                marginLeft: 40,
                marginBottom: 5,
              }}
            >
              {this.renderMultiSelect(
                institutesTags,
                this.state.selectedInstitutesTagIds,
                "selectedInstitutesTagIds",
                "Tags",
                (event) => {
                  this.setState({
                    selectedInstitutesTagIds: event,
                  });
                  if (event.length > 0) {
                    const tagsList = event.map((tag) => {
                      return tag.value;
                    });
                    filteredStudent = students.filter((student) =>
                      student.student_tags.some((tag) =>
                        tagsList.includes(tag.value)
                      )
                    );
                    this.setState({
                      filteredStudents: filteredStudent,
                      page: 1,
                    });
                  } else if (event.length === 0) {
                    this.setState({ filteredStudents: students, page: 1 });
                  }
                }
              )}
            </div>
          </div>
          {
            <>
              <div>
                <div style={containerStyle}>
                  <table
                    className="table table-bordered"
                    style={{
                      boxShadow: "1px 2px 6px #8B9DAF33",
                      marginBottom: 10,
                      marginLeft: 20,
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          fontSize: 16,
                          fontWeight: "700",
                          height: 55,
                          paddingLeft: 20,
                        }}
                      >
                        <td>Students</td>
                        <td>Name</td>
                        <td>Classroom</td>
                        <td>Campus</td>
                        <td>Tags</td>
                        <td style={{ textAlign: "center" }}>
                          Assign{" "}
                          <input
                            type="checkbox"
                            onChange={() => {
                              this.handleSelectAllStudents(
                                filteredStudents,
                                feeDueAssignedItems
                              );
                            }}
                          />
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredStudents
                        .slice((page - 1) * perPage, page * perPage)
                        .map((items, index) => {
                          const isfeebundle = feeDueAssignedItems.includes(
                            items
                          )
                            ? true
                            : false;
                          return (
                            <tr key={index}>
                              <td>{items.badge_id}</td>
                              <td>
                                {items.first_name ? items.first_name : "-"}
                              </td>
                              <td>{items.classroom_name}</td>
                              <td>{items.campus_name}</td>
                              <td>
                                {items.student_tags
                                  ? items.student_tags
                                      .map((tag) => {
                                        return tag.label;
                                      })
                                      .join(", ")
                                  : "-"}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {isfeebundle ? (
                                  <input
                                    type="checkbox"
                                    checked={isfeebundle}
                                    disabled
                                    onChange={() =>
                                      this.setState({
                                        isfeebundle: !isfeebundle,
                                      })
                                    }
                                  />
                                ) : (
                                  <input
                                    type="checkbox"
                                    checked={
                                      isfeebundle ||
                                      selectedItemsToAssignDue.includes(
                                        items.id
                                      )
                                    }
                                    onChange={() => {
                                      this.setState({
                                        isfeebundle: !isfeebundle,
                                      });
                                      this.handleSelectedStudents(items.id);
                                    }}
                                  />
                                )}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
                <Pagination
                  activePage={page}
                  itemsCountPerPage={perPage}
                  totalItemsCount={filteredStudents.length}
                  pageRangeDisplayed={IS_MOBILE ? 3 : 7}
                  onChange={(pageNumber) => this.setState({ page: pageNumber })}
                />
              </div>
            </>
          }
          <div>
            <div
              className="Button Primary-Button"
              style={{
                opacity: enableButtonToAssign ? 1 : 0.5,
                cursor: enableButtonToAssign ? "pointer" : "not-allowed",
                width,
                float: "right",
              }}
              onClick={
                enableButtonToAssign
                  ? () => {
                      this.props
                        .assignFeeDues(
                          selectedItemsToAssignDue,
                          "Students",
                          selectedFeeBundle.id
                        )
                        .then((response) => {
                          if (response.success) {
                            this.handleCloseFeeDueAssignmentModal();
                          }
                        });
                    }
                  : () => {}
              }
            >
              Assign
            </div>
            <div
              className="Button Secondary-Button"
              style={{ width, marginRight: 5, float: "right" }}
              onClick={this.handleCloseFeeDueAssignmentModal}
            >
              Cancel
            </div>
          </div>
        </fieldset>
      </form>
    );
  }

  renderFeeForm(isEditForm = false) {
    const { newFeeDetails, currentFeeDetails } = this.state;
    const feeDetails = isEditForm ? currentFeeDetails : newFeeDetails;
    const { name, academic_year } = feeDetails;
    const labelStyle = {
      display: "flex",
      justifyContent: "flex-start",
      width: 120,
    };
    const containerStyle = {
      display: "flex",
      margin: "10px 0px",
      maxWidth: 700,
      alignItems: "center",
    };

    if (this.props.feeBundleUpdateLoader) {
      return <Loader height={100} />;
    }

    return (
      <form
        onSubmit={(event) => this.handleFormSubmit(event, isEditForm)}
        onReset={() =>
          this.setState({ showEditModal: false, displayFeeForm: false })
        }
      >
        <fieldset
          style={{ width: isEditForm ? !IS_MOBILE && 570 : !IS_MOBILE && 750 }}
        >
          <legend>Fee Details:</legend>
          <div style={containerStyle}>
            <label style={labelStyle} htmlFor="fee_name">
              Name:
            </label>
            <input
              value={name}
              onChange={(event) =>
                this.handleInputChange(event, "name", isEditForm)
              }
              style={{
                marginLeft: 10,
                width: isEditForm ? !IS_MOBILE && 400 : !IS_MOBILE && 450,
              }}
              type="text"
              name="fee_name"
              id="fee_name"
              maxLength="100"
              required
              aria-required="true"
            />
          </div>
          <div style={containerStyle}>
            <label style={labelStyle} htmlFor="academic_year">
              Academic Year:
            </label>
            <input
              type="number"
              min="2000"
              max="2199"
              step="1"
              value={academic_year[0]}
              onChange={(event) => {
                this.handleInputChange(event, "academicYear0", isEditForm);
              }}
              style={{ margin: "0 10px" }}
              name="academic_year"
              id="academic_year"
              aria-required="true"
            />
            -
            <input
              type="number"
              min="2000"
              max="2199"
              step="1"
              value={academic_year[1]}
              onChange={(event) => {
                this.handleInputChange(event, "academicYear1", isEditForm);
              }}
              style={{ margin: "0 10px" }}
              name="academic_year"
              id="academic_year"
              aria-required="true"
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: IS_MOBILE ? "center" : "flex-start",
            }}
          >
            <button
              type="reset"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: 180,
                height: 35,
                borderColor: StyleConstants.color.darkBlue,
                borderWidth: 1,
                borderRadius: 4,
                lineHeight: 0,
                fontSize: 14,
                cursor: "pointer",
                marginTop: 10,
                marginRight: 15,
                fontFamily: "'Poppins', sans-serif",
              }}
              onClick={this.handleCloseEditModal}
            >
              Cancel
            </button>
            <button
              type="submit"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: 180,
                height: 35,
                backgroundColor: StyleConstants.color.darkBlue,
                borderColor: StyleConstants.color.darkBlue,
                color: "#FFFFFF",
                borderRadius: 4,
                lineHeight: 0,
                fontSize: 14,
                cursor: "pointer",
                marginTop: 10,
                fontFamily: "'Poppins', sans-serif",
              }}
            >
              Submit
            </button>
          </div>
        </fieldset>
      </form>
    );
  }

  renderFeeCreationPart() {
    const { displayFeeForm } = this.state;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "30px 50px",
        }}
      >
        {(!displayFeeForm || this.state.showEditModal) && (
          <div
            className="Button Primary-Button"
            style={{ width: 150 }}
            onClick={() => this.setState({ displayFeeForm: true })}
          >
            Create Fee Bundle
          </div>
        )}
        {displayFeeForm && !this.state.showEditModal && this.renderFeeForm()}
      </div>
    );
  }

  markFeeBundleAsInactive() {
    const { currentFeeDetails } = this.state;
    this.props
      .toggleFeeBundleStatus(currentFeeDetails.id, !currentFeeDetails.active)
      .then((response) => {
        if (response.success) {
          this.setState({ currentFeeDetails: { name: "" } });
        }
      });
  }

  renderCreatedFeeDetails(feeBundles) {
    const { isFinance } = this.props;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "0px 50px",
          paddingBottom: 30,
          overflowX: "auto",
        }}
      >
        {this.state[feeBundles].map((feeBundle, index) => {
          const feeDetails = this.props.feeDetails.filter(
            (feeDetail) => feeDetail.fee_bundle_id === feeBundle.id
          );
          feeBundle.total_amount_collected =
            feeBundle.total_amount_collected || 0;
          const total = feeDetails
            .reduce((sum, fee) => sum + parseFloat(fee.total_amount), 0)
            .toFixed(2);
          const total_amount = feeBundle?.badge_ids?.length * total;
          const pending =
            total_amount == 0
              ? 0
              : (
                  ((total_amount - feeBundle.total_amount_collected) /
                    total_amount) *
                  100
                ).toFixed(2);

          return (
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: 20,
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      fontSize: 20,
                      fontWeight: "bold",
                      marginRight: 15,
                    }}
                  >
                    {index + 1}.{feeBundle.name}{" "}
                    {feeBundle.academic_year.length > 0 &&
                      "(" +
                        feeBundle.academic_year[0] +
                        " - " +
                        feeBundle.academic_year[1] +
                        ")"}{" "}
                    (Total: {convertToCurrencyFormat(parseInt(total, 10))})
                  </div>
                  {!isFinance && feeBundle.active && (
                    <div
                      className="Button Secondary-Button"
                      style={{ width: 70, marginRight: 15 }}
                      onClick={() =>
                        this.setState({
                          showEditModal: true,
                          displayFeeForm: true,
                          currentFeeDetails: feeBundle,
                        })
                      }
                    >
                      Edit
                    </div>
                  )}
                  {feeBundle.active && (
                    <div
                      className="Button Primary-Button"
                      style={{ width: 100 }}
                      onClick={async () => {
                        const { students } = this.props;
                        this.setState({
                          loader: true,
                          showEditModal: true,
                          selectedFeeBundle: feeBundle,
                        });
                        students.length === 0 &&
                          (await this.props.getStudentsData());
                        this.setState({
                          loader: false,
                          filteredStudents: this.props.students,
                        });
                      }}
                    >
                      Assign
                    </div>
                  )}
                </div>
                {!isFinance && (
                  <div
                    className="Button Primary-Button"
                    style={{
                      backgroundColor: feeBundle.active && "red",
                      borderColor: feeBundle.active && "red",
                    }}
                    onClick={() =>
                      this.setState(
                        {
                          currentFeeDetails: feeBundle,
                        },
                        () => {
                          this.markFeeBundleAsInactive();
                          window.location.reload();
                        }
                      )
                    }
                  >
                    {feeBundle.active ? "Mark as Inactive" : "Mark as Active"}
                  </div>
                )}
              </div>
              <div
                style={{
                  border: "1px solid black",
                  marginTop: 15,
                  borderRadius: 4,
                }}
              >
                <div
                  style={{
                    margin: "30px 50px 10px",
                    fontSize: 18,
                    fontWeight: 400,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    Total Students:{" "}
                    {feeBundle.badge_ids ? feeBundle.badge_ids.length : 0}
                  </div>
                  <div style={{ marginTop: 10 }}>
                    Total Expected: {convertToCurrencyFormat(total_amount)}
                  </div>
                </div>
                <div
                  style={{
                    margin: "10px 50px 20px",
                    fontSize: 18,
                    fontWeight: 400,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    Amount Collected:{" "}
                    {convertToCurrencyFormat(feeBundle.total_amount_collected)}
                  </div>
                  <div style={{ marginTop: 10 }}>
                    Pending(%): {pending}
                    {"%"}
                  </div>
                </div>
                <Edit feeBundleId={feeBundle.id} feeDetails={feeDetails}></Edit>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  noPermission() {
    return (
      <div
        style={{
          paddingTop: 200,
          paddingLeft: 300,
          width: "100%",
          backgroundColor: "#F5F8FA",
          fontSize: "20px",
        }}
      >
        <span style={{ borderStyle: "solid", padding: "10px" }}>
          You dont have permission to access to this page{" "}
        </span>
      </div>
    );
  }

  render() {
    const { showEditModal, hasAccess, activeFeeBundles, inactiveFeeBundles } =
      this.state;
    const { feeBundles, isFinance } = this.props;
    if (this.props.isLoading) {
      return <Loader />;
    }
    return (
      <div>
        {hasAccess ? (
          <div>
            {!isFinance && this.renderFeeCreationPart()}
            {activeFeeBundles.length > 0 && (
              <div
                style={{
                  fontSize: 28,
                  fontWeight: "bold",
                  paddingLeft: 50,
                  color: StyleConstants.color.darkBlue,
                }}
              >
                Active Fee Bundles
              </div>
            )}
            {this.renderCreatedFeeDetails("activeFeeBundles")}
            {inactiveFeeBundles.length > 0 && (
              <div
                style={{
                  fontSize: 28,
                  fontWeight: "bold",
                  paddingLeft: 50,
                  color: StyleConstants.color.darkBlue,
                }}
              >
                Inactive Fee Bundles
              </div>
            )}
            {this.renderCreatedFeeDetails("inactiveFeeBundles")}
            {showEditModal && this.renderModal()}
          </div>
        ) : (
          this.noPermission()
        )}
      </div>
    );
  }
}

List.propTypes = {
  isLoading: PropTypes.bool,
  feeBundles: PropTypes.array,
  createFeeBundle: PropTypes.func,
  updateFeeBundle: PropTypes.func,
  campuses: PropTypes.array,
  students: PropTypes.array,
  classrooms: PropTypes.array,
  assignFeeDues: PropTypes.func,
  feeDetails: PropTypes.array,
  toggleFeeBundleStatus: PropTypes.func,
};

List.defaultProps = {
  isLoading: false,
  students: [],
  campuses: [],
  feeBundles: [],
  classrooms: [],
  feeDetails: [],
  institutesTags: [],
};

const mapStateToProps = ({ home }) => ({
  isLoading: home.isLoading,
  feeBundles: home.feeBundles,
  campuses: home.campuses,
  students: home.students,
  classrooms: home.classrooms,
  feeDetails: home.feeDetails,
  feeBundleUpdateLoader: home.feeBundleUpdateLoader,
  institutesTags: home.institutesTags,
  isFinance: home.isFinance,
});

export default withRouter(
  connect(mapStateToProps, {
    createFeeBundle,
    updateFeeBundle,
    assignFeeDues,
    getFeesInBundle,
    toggleFeeBundleStatus,
    getStudentsData,
  })(List)
);
